const MONITORING_KEYS = [
    "lastCommunicationInterval",
    "config",
    "nodes",
    "log",
    "hb",
];
/** Normalize .NET / SignalR date shapes to ISO strings for Redux. */
export function normalizeMonitoringTimestamps(raw) {
    var _a;
    if (!raw || typeof raw !== "object")
        return null;
    const o = raw;
    const toIso = (v) => {
        if (v == null)
            return null;
        if (typeof v === "string" && v.trim() !== "")
            return v;
        if (v instanceof Date)
            return v.toISOString();
        return undefined;
    };
    const lastCommunicationInterval = (_a = toIso(o.lastCommunicationInterval)) !== null && _a !== void 0 ? _a : toIso(o.ap);
    const config = toIso(o.config);
    const nodes = toIso(o.nodes);
    const log = toIso(o.log);
    const hb = toIso(o.hb);
    if (lastCommunicationInterval == null &&
        config == null &&
        nodes == null &&
        log == null &&
        hb == null)
        return null;
    return {
        lastCommunicationInterval,
        config,
        nodes,
        log,
        hb,
    };
}
/**
 * Latest activity across all `endPointCommunicationMonitoring` channels (and API fallbacks).
 * Does not use Mongo root `updatedAt`.
 */
export function getLatestApActivityIso(ap) {
    const m = ap.endPointCommunicationMonitoring;
    const candidates = [];
    if (m) {
        const primary = m.lastCommunicationInterval;
        if (typeof primary === "string" && primary.trim() !== "")
            candidates.push(primary);
        for (const k of MONITORING_KEYS) {
            if (k === "lastCommunicationInterval")
                continue;
            const v = m[k];
            if (typeof v === "string" && v.trim() !== "")
                candidates.push(v);
        }
    }
    if (candidates.length === 0) {
        if (ap.lastApCommunication && ap.lastApCommunication.trim() !== "")
            return ap.lastApCommunication;
        if (ap.updatedAt && ap.updatedAt.trim() !== "")
            return ap.updatedAt;
        return "";
    }
    let best = candidates[0];
    let bestMs = Date.parse(best);
    for (let i = 1; i < candidates.length; i++) {
        const ms = Date.parse(candidates[i]);
        if (!Number.isNaN(ms) && (Number.isNaN(bestMs) || ms > bestMs)) {
            best = candidates[i];
            bestMs = ms;
        }
    }
    return !Number.isNaN(bestMs) ? new Date(bestMs).toISOString() : best;
}
